import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

export default {
  container: () => css`
    display: flex;
  `,
  iconContainer: (isEmpty) => {
    return css`
      padding-inline-end: ${isEmpty ? '25px' : '10px'};
    `
  },
  icon: (color) => {
    return css`
      background-color: ${(color === 'red' && colors.danger30) ||
      (color === 'orange' && colors.yellow40) ||
      (color === 'green' && colors.green40) ||
      (color === 'blue' && colors.blue40)};
      border-radius: 50%;
      display: inline-block;
      height: 15px;
      margin-top: 6px;
      width: 15px;
    `
  },
}
